<script setup lang="ts">
import { useFailureTypes } from '@/composables/rc/failure-types'
import type { PartType } from '@/types/rc/miners/PartType'
import { computed } from 'vue'

const props = defineProps<{ partType: PartType; disabled?: boolean }>()

const failureType = defineModel<number>()
const { getFailureTypesOptions } = useFailureTypes()
const options = computed(() => getFailureTypesOptions(props.partType))
</script>

<template>
  <div class="failure-type-select w-full">
    <el-text class="text-text-tertiary">Failure type</el-text>
    <el-select v-model="failureType" placeholder="Select..." :disabled="disabled">
      <el-option v-for="opt in options" :key="opt.value" :value="opt.value" :label="opt.label" />
    </el-select>
  </div>
</template>
